import utils, {axiosWithAuth, deepCase} from '@imt/vue-toolbox/src/utils';

export const authAxios = axiosWithAuth();

export function isObsolete(item, key = 'obsoleteAt') {
    return Boolean(item[key]) && new Date(item[key]) <= new Date();
}

export function fetchPages(policySystemId) {
    if (!policySystemId) {
        return Promise.resolve([]);
    }

    const url = `${process.env.VUE_APP_ADMIN_URL_CMS}/api/v1/policy-systems/${policySystemId}/pages/?include=versions`;

    return authAxios.get(url).then((response) => utils.dataFormatter.deserialize(response.data));
}

export function pagesToOptions(pages) {
    return (pages || [])
        .filter((page) => !isObsolete(page))
        .map((page) => ({value: page.id, label: page.title || page.id}));
}

export function fetchUassists() {
    const url = `${process.env.VUE_APP_POLICY_DATA_URL}/api/v1/uassists/legacy/`;

    return authAxios.get(url).then((response) => deepCase(response.data).data);
}

export function uassistsToOptions(uassists, actionType) {
    return (uassists || [])
        .filter((uassist) => `uassist_${uassist.uassistType}` === actionType)
        .map((uassist) => [`${uassist.uassistCode}: ${uassist.description}`, uassist.uassistCode, uassist.description]);
}
